export const kostnaderTemplate = [
  {
    text: "Fastelavnsris",
    name: "kostnadFastelavensris",
    kostnadFastelavensris: "",
    placeholder: "Beløp",
  },
  {
    text: "Maiblomst",
    name: "kostnadMaiblomst",
    kostnadMaiblomst: "",
    placeholder: "Beløp",
  },
  {
    text: "Adventskalender",
    name: "kostnadAdventskalender",
    kostnadAdventskalender: "",
    placeholder: "Beløp",
  },
  {
    text: "Basar, messe, utlodning, bingo mm.",
    name: "kostnadBasarMesseUtlodningBingoMm",
    kostnadBasarMesseUtlodningBingoMm: "",
    placeholder: "Beløp",
  },
  {
    text: "N.K.S Fond + Min dag i dag",
    name: "nksFondMinDagIDag",
    nksFondMinDagIDag: "",
    placeholder: "",
  },
  {
    text: "Gaver/økonomiske bidrag",
    name: "gaverOkonomiskeBidrag",
    gaverOkonomiskeBidrag: "",
    placeholder: "Beløp",
  },
  {
    text: "Aktiviteter",
    name: "aktiviteter",
    aktiviteter: "",
    placeholder: "Beløp",
  },
  {
    text: "Husleie (dersom foreningen leier lokaler)",
    name: "husleie",
    husleie: "",
    placeholder: "Beløp",
  },
  {
    text: "Andre driftsutgifter",
    name: "andreDriftsutgifter",
    andreDriftsutgifter: "",
    placeholder: "Beløp",
  },
  {
    text: "KOSTNADER EGEN EIENDOM:",
    name: "kostnaderEgenEiendom",
    placeholder: "",
    colSpan: 2,
    input: true,
  },
  {
    text: "Driftskostnader",
    name: "driftskostnader",
    driftskostnader: "",
    placeholder: "Beløp",
  },

  {
    text: "Vedlikehold",
    name: "vedlikehold",
    vedlikehold: "",
    placeholder: "Beløp",
  },
  {
    text: "Avskrivninger",
    name: "avskrivninger",
    avskrivninger: "",
    placeholder: "Beløp",
  },
];
export const inntekterTemplate = [
  {
    text: "Fastelavnsris",
    name: "inntektFastelavensris",
    inntektFastelavensris: "",
    placeholder: "Beløp",
  },
  {
    text: "Maiblomst",
    name: "inntektMaiblomst",
    inntektMaiblomst: "",
    placeholder: "Beløp",
  },
  {
    text: "Adventskalender",
    name: "inntektAdventskalender",
    inntektAdventskalender: "",
    placeholder: "Beløp",
  },
  {
    text: "Basar, messe, utlodning, bingo mm.",
    name: "inntektBasarMesseUtlodningBingoMm",
    inntektBasarMesseUtlodningBingoMm: "",
    placeholder: "Beløp",
  },
  {
    text: "Grasrotandelen",
    name: "grasrotandelen",
    grasrotandelen: "",
    placeholder: "Beløp",
  },
  {
    text: "Gaver",
    name: "gaver",
    gaver: "",
    placeholder: "Beløp",
  },
  {
    text: "MVA Refusjon",
    name: "mvaRefusjon",
    mvarefusjon: "",
    placeholder: "Beløp",
  },
  {
    text: "Tilbakeført kontigent",
    name: "tilbakefortKontigent",
    tilbakefortKontigent: "",
    placeholder: "Beløp",
  },
  {
    text: "Offentlige tilskudd",
    name: "offentligeTilskudd",
    offentligeTilskudd: "",
    placeholder: "Beløp",
  },
  {
    text: "Tilskudd som er øremerket",
    name: "tilskuddSomErOremerket",
    tilskuddSomErOremerket: "",
    placeholder: "Beløp",
  },
  {
    text: "Andre innteker",
    name: "andreInntekter",
    andreInntekter: "",
    placeholder: "Beløp",
  },
  {
    text: "Leieinntekter egen eiendom",
    name: "leieinntekterEgenEiendom",
    leieinntekterEgenEiendom: "",
    placeholder: "Beløp",
  },
  {
    text: "Faste leieinntekter på egen eiendom",
    name: "fasteLeieinntekterPaEgenEiendom",
    fasteLeieinntekterPaEgenEiendom: "",
    placeholder: "Beløp",
  },
];
export const kasseOgBankTemplate = [
  {
    text: "Kasse og bank",
    name: "kasseOgBank",
    kasseOgBank: "",
    placeholder: "Beløp",
  },
  {
    text: "Beholdning av obligasjoner, aksjer, eller andre verdipapirer",
    name: "beholdningObligasjonerAksjerVerdipapir",
    beholdningObligasjonerAksjerVerdipapir: "",
    placeholder: "Beløp",
  },
  {
    text: "Verdien av fast eiendom (ta med verdien av alle faste eiendommer)",
    name: "verdienAvFastEiendom",
    verdienAvFastEiendom: "",
    placeholder: "Beløp",
  },
];
